var _createClass = require("/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _inherits = require("/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _wrapNativeSuper = require("/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
(function () {
  "use strict";

  var t = {
      831: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = /*#__PURE__*/function (_Error) {
          _inherits(s, _Error);
          var _super = _createSuper(s);
          function s(t, e, _s, i, n) {
            var _this;
            _classCallCheck(this, s);
            _this = _super.call(this, t + ":" + _s + ":" + i + ": " + e), _this.reason = e, _this.filename = t, _this.line = _s, _this.column = i, _this.source = n;
            return _this;
          }
          return _createClass(s);
        }( /*#__PURE__*/_wrapNativeSuper(Error));
        e.default = s;
      },
      711: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = /*#__PURE__*/function () {
          function _class(t, e, s) {
            _classCallCheck(this, _class);
            this.start = t, this.end = e, this.source = s;
          }
          return _createClass(_class);
        }();
      },
      607: function _(t, e, s) {
        var i = this && this.__createBinding || (Object.create ? function (t, e, s, i) {
            void 0 === i && (i = s);
            var n = Object.getOwnPropertyDescriptor(e, s);
            n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
              enumerable: !0,
              get: function get() {
                return e[s];
              }
            }), Object.defineProperty(t, i, n);
          } : function (t, e, s, i) {
            void 0 === i && (i = s), t[i] = e[s];
          }),
          n = this && this.__exportStar || function (t, e) {
            for (var s in t) {
              "default" === s || Object.prototype.hasOwnProperty.call(e, s) || i(e, t, s);
            }
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.stringify = e.parse = void 0;
        var r = s(654);
        Object.defineProperty(e, "parse", {
          enumerable: !0,
          get: function get() {
            return r.default;
          }
        });
        var o = s(373);
        Object.defineProperty(e, "stringify", {
          enumerable: !0,
          get: function get() {
            return o.default;
          }
        }), n(s(371), e), n(s(831), e), n(s(711), e);
      },
      654: function _(t, e, s) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.parse = void 0;
        var i = s(831),
          n = s(711),
          r = s(371),
          o = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
        function c(t) {
          return t ? t.trim() : "";
        }
        function u(t, e) {
          var s = t && "string" == typeof t.type,
            i = s ? t : e;
          for (var _e in t) {
            var _s2 = t[_e];
            Array.isArray(_s2) ? _s2.forEach(function (t) {
              u(t, i);
            }) : _s2 && "object" == typeof _s2 && u(_s2, i);
          }
          return s && Object.defineProperty(t, "parent", {
            configurable: !0,
            writable: !0,
            enumerable: !1,
            value: e || null
          }), t;
        }
        e.parse = function (t, e) {
          e = e || {};
          var s = 1,
            a = 1;
          function m() {
            var t = {
              line: s,
              column: a
            };
            return function (i) {
              return i.position = new n.default(t, {
                line: s,
                column: a
              }, (null == e ? void 0 : e.source) || ""), g(), i;
            };
          }
          var p = [];
          function h(n) {
            var r = new i.default((null == e ? void 0 : e.source) || "", n, s, a, t);
            if (!(null == e ? void 0 : e.silent)) throw r;
            p.push(r);
          }
          function l() {
            return y(/^{\s*/);
          }
          function f() {
            return y(/^}/);
          }
          function d() {
            var e;
            var s = [];
            for (g(), v(s); t.length && "}" !== t.charAt(0) && (e = M() || P());) {
              e && (s.push(e), v(s));
            }
            return s;
          }
          function y(e) {
            var i = e.exec(t);
            if (!i) return;
            var n = i[0];
            return function (t) {
              var e = t.match(/\n/g);
              e && (s += e.length);
              var i = t.lastIndexOf("\n");
              a = ~i ? t.length - i : a + t.length;
            }(n), t = t.slice(n.length), i;
          }
          function g() {
            y(/^\s*/);
          }
          function v(t) {
            var e;
            for (t = t || []; e = C();) {
              e && t.push(e);
            }
            return t;
          }
          function C() {
            var e = m();
            if ("/" !== t.charAt(0) || "*" !== t.charAt(1)) return;
            var s = y(/^\/\*[^]*?\*\//);
            return s ? e({
              type: r.CssTypes.comment,
              comment: s[0].slice(2, -2)
            }) : h("End of comment missing");
          }
          function T() {
            var t = y(/^([^{]+)/);
            if (!t) return;
            var e = c(t[0]).replace(/\/\*[^]*?\*\//gm, "");
            return -1 === e.indexOf(",") ? [e] : e.replace(/("|')(?:\\\1|.)*?,(?:\\\1|.)*?\1|\(.*?,.*?\)/g, function (t) {
              return t.replace(/,/g, "‌");
            }).split(",").map(function (t) {
              return c(t.replace(/\u200C/g, ","));
            });
          }
          function b() {
            var t = m(),
              e = y(/^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
            if (!e) return;
            var s = c(e[0]);
            if (!y(/^:\s*/)) return h("property missing ':'");
            var i = y(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/),
              n = t({
                type: r.CssTypes.declaration,
                property: s.replace(o, ""),
                value: i ? c(i[0]).replace(o, "") : ""
              });
            return y(/^[;\s]*/), n;
          }
          function j() {
            var t = [];
            if (!l()) return h("missing '{'");
            var e;
            for (v(t); e = b();) {
              e && (t.push(e), v(t));
            }
            return f() ? t : h("missing '}'");
          }
          function k() {
            var t;
            var e = [],
              s = m();
            for (; t = y(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/);) {
              e.push(t[1]), y(/^,\s*/);
            }
            if (e.length) return s({
              type: r.CssTypes.keyframe,
              values: e,
              declarations: j() || []
            });
          }
          var _ = w("import"),
            V = w("charset"),
            O = w("namespace");
          function w(t) {
            var e = new RegExp("^@" + t + "\\s*([^;]+);");
            return function () {
              var s = m(),
                i = y(e);
              if (!i) return;
              var n = {
                type: t
              };
              return n[t] = i[1].trim(), s(n);
            };
          }
          function M() {
            if ("@" === t[0]) return function () {
              var t = m(),
                e = y(/^@([-\w]+)?keyframes\s*/);
              if (!e) return;
              var s = e[1],
                i = y(/^([-\w]+)\s*/);
              if (!i) return h("@keyframes missing name");
              var n = i[1];
              if (!l()) return h("@keyframes missing '{'");
              var o,
                c = v();
              for (; o = k();) {
                c.push(o), c = c.concat(v());
              }
              return f() ? t({
                type: r.CssTypes.keyframes,
                name: n,
                vendor: s,
                keyframes: c
              }) : h("@keyframes missing '}'");
            }() || function () {
              var t = m(),
                e = y(/^@media *([^{]+)/);
              if (!e) return;
              var s = c(e[1]);
              if (!l()) return h("@media missing '{'");
              var i = v().concat(d());
              return f() ? t({
                type: r.CssTypes.media,
                media: s,
                rules: i
              }) : h("@media missing '}'");
            }() || function () {
              var t = m(),
                e = y(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
              if (e) return t({
                type: r.CssTypes.customMedia,
                name: c(e[1]),
                media: c(e[2])
              });
            }() || function () {
              var t = m(),
                e = y(/^@supports *([^{]+)/);
              if (!e) return;
              var s = c(e[1]);
              if (!l()) return h("@supports missing '{'");
              var i = v().concat(d());
              return f() ? t({
                type: r.CssTypes.supports,
                supports: s,
                rules: i
              }) : h("@supports missing '}'");
            }() || _() || V() || O() || function () {
              var t = m(),
                e = y(/^@([-\w]+)?document *([^{]+)/);
              if (!e) return;
              var s = c(e[1]),
                i = c(e[2]);
              if (!l()) return h("@document missing '{'");
              var n = v().concat(d());
              return f() ? t({
                type: r.CssTypes.document,
                document: i,
                vendor: s,
                rules: n
              }) : h("@document missing '}'");
            }() || function () {
              var t = m();
              if (!y(/^@page */)) return;
              var e = T() || [];
              if (!l()) return h("@page missing '{'");
              var s,
                i = v();
              for (; s = b();) {
                i.push(s), i = i.concat(v());
              }
              return f() ? t({
                type: r.CssTypes.page,
                selectors: e,
                declarations: i
              }) : h("@page missing '}'");
            }() || function () {
              var t = m();
              if (!y(/^@host\s*/)) return;
              if (!l()) return h("@host missing '{'");
              var e = v().concat(d());
              return f() ? t({
                type: r.CssTypes.host,
                rules: e
              }) : h("@host missing '}'");
            }() || function () {
              var t = m();
              if (!y(/^@font-face\s*/)) return;
              if (!l()) return h("@font-face missing '{'");
              var e,
                s = v();
              for (; e = b();) {
                s.push(e), s = s.concat(v());
              }
              return f() ? t({
                type: r.CssTypes.fontFace,
                declarations: s
              }) : h("@font-face missing '}'");
            }();
          }
          function P() {
            var t = m(),
              e = T();
            return e ? (v(), t({
              type: r.CssTypes.rule,
              selectors: e,
              declarations: j() || []
            })) : h("selector missing");
          }
          return u(function () {
            var t = d();
            return {
              type: r.CssTypes.stylesheet,
              stylesheet: {
                source: null == e ? void 0 : e.source,
                rules: t,
                parsingErrors: p
              }
            };
          }());
        }, e.default = e.parse;
      },
      854: function _(t, e, s) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var i = s(371);
        e.default = /*#__PURE__*/function () {
          function _class2(t) {
            _classCallCheck(this, _class2);
            this.level = 0, this.indentation = "  ", this.compress = !1, "string" == typeof (null == t ? void 0 : t.indent) && (this.indentation = null == t ? void 0 : t.indent), (null == t ? void 0 : t.compress) && (this.compress = !0);
          }
          _createClass(_class2, [{
            key: "emit",
            value: function emit(t, e) {
              return t;
            }
          }, {
            key: "indent",
            value: function indent(t) {
              return this.level = this.level || 1, t ? (this.level += t, "") : Array(this.level).join(this.indentation);
            }
          }, {
            key: "visit",
            value: function visit(t) {
              switch (t.type) {
                case i.CssTypes.stylesheet:
                  return this.stylesheet(t);
                case i.CssTypes.rule:
                  return this.rule(t);
                case i.CssTypes.declaration:
                  return this.declaration(t);
                case i.CssTypes.comment:
                  return this.comment(t);
                case i.CssTypes.charset:
                  return this.charset(t);
                case i.CssTypes.document:
                  return this.document(t);
                case i.CssTypes.customMedia:
                  return this.customMedia(t);
                case i.CssTypes.fontFace:
                  return this.fontFace(t);
                case i.CssTypes.host:
                  return this.host(t);
                case i.CssTypes.import:
                  return this.import(t);
                case i.CssTypes.keyframes:
                  return this.keyframes(t);
                case i.CssTypes.keyframe:
                  return this.keyframe(t);
                case i.CssTypes.media:
                  return this.media(t);
                case i.CssTypes.namespace:
                  return this.namespace(t);
                case i.CssTypes.page:
                  return this.page(t);
                case i.CssTypes.supports:
                  return this.supports(t);
              }
            }
          }, {
            key: "mapVisit",
            value: function mapVisit(t, e) {
              var s = "";
              e = e || "";
              for (var _i = 0, n = t.length; _i < n; _i++) {
                s += this.visit(t[_i]), e && _i < n - 1 && (s += this.emit(e));
              }
              return s;
            }
          }, {
            key: "compile",
            value: function compile(t) {
              return this.compress ? t.stylesheet.rules.map(this.visit, this).join("") : this.stylesheet(t);
            }
          }, {
            key: "stylesheet",
            value: function stylesheet(t) {
              return this.mapVisit(t.stylesheet.rules, "\n\n");
            }
          }, {
            key: "comment",
            value: function comment(t) {
              return this.compress ? this.emit("", t.position) : this.emit(this.indent() + "/*" + t.comment + "*/", t.position);
            }
          }, {
            key: "import",
            value: function _import(t) {
              return this.emit("@import " + t.import + ";", t.position);
            }
          }, {
            key: "media",
            value: function media(t) {
              return this.compress ? this.emit("@media " + t.media, t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit("@media " + t.media, t.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(t.rules, "\n\n") + this.emit(this.indent(-1) + "\n}");
            }
          }, {
            key: "document",
            value: function document(t) {
              var e = "@" + (t.vendor || "") + "document " + t.document;
              return this.compress ? this.emit(e, t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit(e, t.position) + this.emit("  {\n" + this.indent(1)) + this.mapVisit(t.rules, "\n\n") + this.emit(this.indent(-1) + "\n}");
            }
          }, {
            key: "charset",
            value: function charset(t) {
              return this.emit("@charset " + t.charset + ";", t.position);
            }
          }, {
            key: "namespace",
            value: function namespace(t) {
              return this.emit("@namespace " + t.namespace + ";", t.position);
            }
          }, {
            key: "supports",
            value: function supports(t) {
              return this.compress ? this.emit("@supports " + t.supports, t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit("@supports " + t.supports, t.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(t.rules, "\n\n") + this.emit(this.indent(-1) + "\n}");
            }
          }, {
            key: "keyframes",
            value: function keyframes(t) {
              return this.compress ? this.emit("@" + (t.vendor || "") + "keyframes " + t.name, t.position) + this.emit("{") + this.mapVisit(t.keyframes) + this.emit("}") : this.emit("@" + (t.vendor || "") + "keyframes " + t.name, t.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(t.keyframes, "\n") + this.emit(this.indent(-1) + "}");
            }
          }, {
            key: "keyframe",
            value: function keyframe(t) {
              var e = t.declarations;
              return this.compress ? this.emit(t.values.join(","), t.position) + this.emit("{") + this.mapVisit(e) + this.emit("}") : this.emit(this.indent()) + this.emit(t.values.join(", "), t.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(e, "\n") + this.emit(this.indent(-1) + "\n" + this.indent() + "}\n");
            }
          }, {
            key: "page",
            value: function page(t) {
              if (this.compress) {
                var _e2 = t.selectors.length ? t.selectors.join(", ") : "";
                return this.emit("@page " + _e2, t.position) + this.emit("{") + this.mapVisit(t.declarations) + this.emit("}");
              }
              var e = t.selectors.length ? t.selectors.join(", ") + " " : "";
              return this.emit("@page " + e, t.position) + this.emit("{\n") + this.emit(this.indent(1)) + this.mapVisit(t.declarations, "\n") + this.emit(this.indent(-1)) + this.emit("\n}");
            }
          }, {
            key: "fontFace",
            value: function fontFace(t) {
              return this.compress ? this.emit("@font-face", t.position) + this.emit("{") + this.mapVisit(t.declarations) + this.emit("}") : this.emit("@font-face ", t.position) + this.emit("{\n") + this.emit(this.indent(1)) + this.mapVisit(t.declarations, "\n") + this.emit(this.indent(-1)) + this.emit("\n}");
            }
          }, {
            key: "host",
            value: function host(t) {
              return this.compress ? this.emit("@host", t.position) + this.emit("{") + this.mapVisit(t.rules) + this.emit("}") : this.emit("@host", t.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(t.rules, "\n\n") + this.emit(this.indent(-1) + "\n}");
            }
          }, {
            key: "customMedia",
            value: function customMedia(t) {
              return this.emit("@custom-media " + t.name + " " + t.media + ";", t.position);
            }
          }, {
            key: "rule",
            value: function rule(t) {
              var e = t.declarations;
              if (!e.length) return "";
              if (this.compress) return this.emit(t.selectors.join(","), t.position) + this.emit("{") + this.mapVisit(e) + this.emit("}");
              var s = this.indent();
              return this.emit(t.selectors.map(function (t) {
                return s + t;
              }).join(",\n"), t.position) + this.emit(" {\n") + this.emit(this.indent(1)) + this.mapVisit(e, "\n") + this.emit(this.indent(-1)) + this.emit("\n" + this.indent() + "}");
            }
          }, {
            key: "declaration",
            value: function declaration(t) {
              return this.compress ? this.emit(t.property + ":" + t.value, t.position) + this.emit(";") : this.emit(this.indent()) + this.emit(t.property + ": " + t.value, t.position) + this.emit(";");
            }
          }]);
          return _class2;
        }();
      },
      373: function _(t, e, s) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var i = s(854);
        e.default = function (t, e) {
          return new i.default(e || {}).compile(t);
        };
      },
      371: function _(t, e) {
        var s;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CssTypes = void 0, (s = e.CssTypes || (e.CssTypes = {})).stylesheet = "stylesheet", s.rule = "rule", s.declaration = "declaration", s.comment = "comment", s.charset = "charset", s.document = "document", s.customMedia = "custom-media", s.fontFace = "font-face", s.host = "host", s.import = "import", s.keyframes = "keyframes", s.keyframe = "keyframe", s.media = "media", s.namespace = "namespace", s.page = "page", s.supports = "supports";
      }
    },
    e = {},
    s = function s(i) {
      var n = e[i];
      if (void 0 !== n) return n.exports;
      var r = e[i] = {
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, s), r.exports;
    }(607);
  module.exports = s;
})();